// Gouvernance — Légende des périmètres des 4 Gardiens.
import { Shield } from "lucide-react";

export default function GouvPerimetresWidget() {
  return (
    <div className="p-4 rounded-xl bg-zinc-900/30 border border-zinc-800" data-testid="gouv-perimetres-widget">
      <h3 className="text-sm font-semibold text-white mb-3 flex items-center gap-2">
        <Shield className="w-4 h-4 text-zinc-400" />
        Périmètres des 4 Gardiens
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 text-xs">
        <Item color="bg-blue-400" title="Groot" titleClass="text-blue-300"
          text="Analyse statique du code source (MT-001/002, CODE-003, INT-001) + scan Mongo de l'isolation multi-tenant." />
        <Item color="bg-pink-400" title="Gamora" titleClass="text-pink-300"
          text="Cohérence des données métier TEF : 11 checks (orphelins, statuts ANAH, doublons, DAL, dates)." />
        <Item color="bg-purple-400" title="Gatekeeper" titleClass="text-purple-300"
          text="Gate CI/CD pré-deploy : exécute Groot + 7 tests E2E. Bloque le merge si critiques ou E2E KO." />
        <Item color="bg-violet-400" title="Nebula" titleClass="text-violet-300"
          text="Monitoring runtime continu post-deploy : smoke endpoints, design (WCAG), parcours métier, qualité code." />
      </div>
    </div>
  );
}

function Item({ color, title, titleClass, text }) {
  return (
    <div className="flex items-start gap-2">
      <div className={`w-2 h-2 rounded-full ${color} mt-1.5`} />
      <div>
        <p className={`font-medium ${titleClass}`}>{title}</p>
        <p className="text-zinc-500">{text}</p>
      </div>
    </div>
  );
}
